import { type JSX, type ReactNode } from 'react';
// oxlint-disable-next-line no-restricted-imports
import { RequiredAsterisk } from '@launchpad-ui/core';
import cx from 'clsx';

import type { AnyFormRecord, FormState } from '../../formUtils';

import { FieldError } from './FieldError';
import { FormGroup } from './FormGroup';
import { FormHint } from './FormHint';

import '../../components/styles/FormField.css';

type FormFieldProps = {
  isRequired: boolean;
  label?: string;
  name: string;
  htmlFor: string;
  hint?: ReactNode;
  errorMessage?: string;
  formState?: FormState<AnyFormRecord>;
  children: JSX.Element;
  className?: string;
  onBlur?: (field: string) => void;
};

export function FormField({
  isRequired,
  label,
  name,
  htmlFor,
  hint,
  errorMessage,
  formState,
  children,
  className,
  onBlur,
}: FormFieldProps) {
  const handleBlur = () => {
    onBlur && onBlur(name);
  };
  return (
    <FormGroup className={cx('FormField', className)} name={name} formState={formState} onBlur={handleBlur}>
      {label && (
        <label htmlFor={htmlFor}>
          {label}
          {isRequired && <RequiredAsterisk />}
        </label>
      )}
      {hint && <FormHint className="FormField-hint u-subtle">{hint}</FormHint>}
      {children}
      <FieldError className="FormField-errorMessage" formState={formState} name={name} errorMessage={errorMessage} />
    </FormGroup>
  );
}
